/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'printer': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(7 7)" _stroke="#00272E"><path pid="0" d="M5.625 14.624h6.75"/><path pid="1" d="M5.625 12.374h6.75"/><path pid="2" d="M4.125 12.375h-2.25a1.504 1.504 0 01-1.5-1.5v-4.5a1.504 1.504 0 011.5-1.5h14.25a1.504 1.504 0 011.5 1.5v4.5a1.504 1.504 0 01-1.5 1.5h-2.25"/><path pid="3" d="M4.125 3.375v-3h7.19c.198 0 .39.08.53.22l1.81 1.81c.14.14.22.332.22.53v.44"/><path pid="4" d="M13.875 16.875a.75.75 0 01-.75.75h-8.25a.75.75 0 01-.75-.75v-6.75h9.75v6.75z"/><circle pid="5" cx="2.625" cy="7.124" r="1"/><polyline pid="6" points="10.875 0.37425 10.875 3.37425 13.875 3.37425"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/printer.js